import { tl } from '../../i18n/t';
import type { RequestItem } from './types';

// Unterlagen, die der Mandant anfordern kann (dieselben Listen wie auf dem Server, wie in der Demo). Die Werte gehen so an
// den Server; angezeigt werden sie mit t(art). Auch Meldungen und Stand hier sind Deutsch und werden beim Anzeigen übersetzt.
export const FIRM_ARTS = [
  tl('Summen- und Saldenliste (SuSa)'),
  tl('Unbedenklichkeitsbescheinigung Finanzamt'),
  tl('Unbedenklichkeitsbescheinigung Krankenkasse'),
  tl('Bescheinigung in Steuersachen'),
  tl('Offene-Posten-Liste'),
  tl('Kontenblätter'),
  tl('Anlagenverzeichnis'),
  tl('Kopie Steuerbescheid'),
  tl('Sonstiges (bitte im Hinweis beschreiben)'),
];
// zu einem Mitarbeiter, der noch da ist
export const EMPLOYEE_ARTS_ACTIVE = [
  tl('Verdienstbescheinigung (z. B. für Elterngeld, Wohngeld, Kredit, Miete)'),
  tl('Entgeltbescheinigung für Krankengeld / Kinderkrankengeld'),
  tl('Lohnsteuerbescheinigung (Ausdruck)'),
  tl('Meldebescheinigung zur Sozialversicherung'),
  tl('Lohnkonto / Jahreslohnjournal'),
  tl('Nebeneinkommensbescheinigung (Agentur für Arbeit)'),
  tl('Bescheinigung für Kurzarbeit / Agentur für Arbeit'),
  tl('Lohnabrechnung erneut (bitte Monat angeben)'),
  tl('Sonstiges (bitte im Hinweis beschreiben)'),
];
// zu einem Mitarbeiter, der gekündigt hat oder schon weg ist
export const EMPLOYEE_ARTS_LEAVING = [
  tl('Arbeitsbescheinigung (Agentur für Arbeit, § 312 SGB III)'),
  tl('Urlaubsbescheinigung (§ 6 BUrlG)'),
  tl('Abmeldebescheinigung zur Sozialversicherung'),
  tl('Letzte Lohnabrechnung mit Urlaubsabgeltung'),
  tl('Lohnsteuerbescheinigung (Ausdruck)'),
  tl('Verdienstbescheinigung (z. B. für Elterngeld, Wohngeld)'),
  tl('Entgeltbescheinigung für Krankengeld'),
  tl('Lohnkonto / Jahreslohnjournal'),
  tl('Sonstiges (bitte im Hinweis beschreiben)'),
];

// Auswahl je nach Stand des Mitarbeiters: weg, gekündigt (beides) oder angemeldet
export function employeeArts(t: { gone: boolean } | null): string[] {
  if (t?.gone) return EMPLOYEE_ARTS_LEAVING;
  if (t) return [...EMPLOYEE_ARTS_LEAVING.slice(0, 4), ...EMPLOYEE_ARTS_ACTIVE];
  return EMPLOYEE_ARTS_ACTIVE;
}

// „Sonstiges“ und „Lohnabrechnung erneut“ brauchen einen Hinweis
export const needsNote = (art: string) => art.includes('(bitte');
export const noteMissing = (art: string) =>
  art.startsWith('Lohnabrechnung') ? tl('Bitte den Monat angeben.') : tl('Bitte beschreiben Sie kurz, was Sie brauchen.');
// für die Meldung „… angefordert“: ohne Erklärung in Klammern
export const shortArt = (art: string) => art.replace(/ \(.*\)$/, '');

// Stand wie in der Demo: Erledigt > Rückfrage > Bereit (Datei da) > In Bearbeitung
export function requestState(r: Pick<RequestItem, 'status' | 'ask' | 'files'>): { label: string; tone: 'ok' | 'warn' | 'none' } {
  if (r.status === 'erledigt') return { label: tl('Erledigt'), tone: 'ok' };
  if (r.ask) return { label: tl('Rückfrage – bitte antworten'), tone: 'warn' };
  if (r.files > 0) return { label: tl('Bereit'), tone: 'ok' };
  return { label: tl('In Bearbeitung'), tone: 'none' };
}

export const requestPath = (id: string) => `/app?anfrage=${id}`;
